export const language = [
  {
    name: "javascript",
    experience: "7 years",
    rate: 5,
  },
  {
    name: "typescript",
    experience: "7 years",
    rate: 5,
  },
  {
    name: "html/css",
    experience: "7 years",
    rate: 5,
  },
  {
    name: "python",
    experience: "4 years",
    rate: 4,
  },
  {
    name: "C++",
    experience: "2 years",
    rate: 3,
  },
  {
    name: "C",
    experience: "2 years",
    rate: 3,
  },
  {
    name: "java",
    experience: "2 years",
    rate: 3,
  },
  {
    name: "dart",
    experience: "2 years",
    rate: 3,
  },
  {
    name: "swift",
    experience: "2 years",
    rate: 2,
  },
];
